import React, { memo } from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";
import { ReactComponent as BackArrow } from "../../assets/img/backArrowNew.svg";

const BackButton = memo(({ to, onClick }) => {
    return (
        <StyledLink onClick={onClick} to={to} className="color-black">
            <BackArrow />
            Back
        </StyledLink>
    );
});

const StyledLink = styled(Link)`
    border-radius: 30px;
    background: #f4f4f4;
    display: flex;
    padding: 8px 16px 8px 12px;
    align-items: center;
    gap: 4px;
    font-size: 15px;
    font-weight: 400;
    width: 95px;
    height: 44px;
`;
export default BackButton;
